import { unescape } from 'lodash';

import { Icon } from '@/components/icon';
import { NotionIcon } from '@/components/icon/notion';

import styles from './reference-block.module.scss';

export interface NotionReferenceProps {
  url?: string;
  name?: string;
  type?: string;
  onOpen?: () => void;
}

export const NotionReference = ({ url, name, type, onOpen }: NotionReferenceProps) => {
  return (
    <div className={styles.notionBlock}>
      <div className={styles.icon}>
        <NotionIcon size={32} />
      </div>
      <div className={styles.title}>
        {unescape(name)}
        <a
          href={url}
          rel="noopener noreferrer nofollow"
          target="_blank"
          className={styles.iconLink}
          draggable={false}
          onClick={onOpen}>
          <Icon name="ExternalLink" size={16} />
        </a>
      </div>
      <div className={styles.subtitle}>Notion {type ?? 'page'}</div>
    </div>
  );
};
